var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticStyle:{"text-align":"center"}},[_c('div',[_vm._v("Development supported by an independent grant from EMD Serono")]),_vm._v(" All rights reserved ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }